import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  colorsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  colorOption: {
    position: 'relative',
    '&:not(:hover) .color-remove-badge': {
      display: 'none',
    },
  },
  colorButton: {
    width: '38px',
    height: '38px',
    minWidth: '38px',
    borderRadius: '3px',
    padding: 0,
  },
  colorButtonWithBorder: {
    width: '38px',
    height: '38px',
    minWidth: '38px',
    borderRadius: '3px',
    padding: 0,
    border: `1px solid ${semanticColors.border.secondary}`,
  },
  addButton: {
    width: '38px',
    height: '38px',
    minWidth: '38px',
    borderRadius: '3px',
    padding: 0,
    backgroundColor: semanticColors.background.secondary,
    border: `1px solid ${semanticColors.border.tertiary}`,
    color: semanticColors.foreground.primary,
    '&:hover': {
      backgroundColor: semanticColors.background.secondary,
    },
  },
  colorBadge: {
    display: 'flex',
    border: `1px solid ${semanticColors.border.secondary}`,
    borderRadius: '50%',
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    backgroundColor: '#ffffff',
    width: '16px',
    height: '16px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  removeBadge: {
    display: 'flex',
    border: `1px solid ${semanticColors.border.secondary}`,
    borderRadius: '50%',
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    backgroundColor: semanticColors.foreground.errorLarge,
    width: '16px',
    height: '16px',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 2,
  },
  selectedIcon: {
    fontSize: '12px',
    color: semanticColors.foreground.successLarge,
  },
  removeIcon: {
    fontSize: '10px',
    color: semanticColors.background.primary,
  },
});
